module.exports = __webpack_public_path__ + "img/popup.45ac969c.png";